import {React, Component} from 'components';
import './subscribe-form.scss';

//HINT CRA — no site API route; POST directly to H (replaces WeFlow w2e 137).
var H_SUBSCRIBE_URL = 'https://h.henrybuilt.com/api/subscribe';

export default class SubscribeForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      submitted: false,
      submitting: false,
      error: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  handleEmailChange(event) {
    this.setState({email: event.target.value});
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (this.state.submitting) return;

    var email = String(this.state.email || '').trim();
    if (!email) return;

    this.setState({submitting: true, error: false});

    try {
      var response = await fetch(H_SUBSCRIBE_URL, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          email,
          subscribedTo: 5, // HB/PO
          source: 2, // Po.com
          subscriptionType: 5 // Projects
        })
      });
      var result = await response.json().catch(() => ({}));
      if (!response.ok || !result.success) {
        this.setState({error: true, submitting: false});
        return;
      }
      this.setState({submitted: true, submitting: false});
      if (this.props.onSubmit) this.props.onSubmit();
    } catch (e) {
      this.setState({error: true, submitting: false});
    }
  }

  render() {
    if (this.state.submitted) {
      return (
        <div className='subscribe-form'>
          <div className='thank-you-message'>Thank you.</div>
        </div>
      );
    }

    return (
      <div className='subscribe-form'>
        <form onSubmit={this.handleSubmit}>
          <input
            type='email'
            name='email'
            id='email'
            placeholder='email'
            required
            value={this.state.email}
            onChange={this.handleEmailChange}
          />
          <button type='submit' disabled={this.state.submitting}>
            {this.state.submitting ? '...' : '→'}
          </button>
          {this.state.error && (
            <div className='error-message'>Something went wrong. Please try again.</div>
          )}
        </form>
      </div>
    );
  }
}
